<template>
<v-progress-linear
  color="primary"
  indeterminate
  rounded
  height="6"
></v-progress-linear>
</template>

<script>
export default {
  name: "Loading"
};
</script>
